// extracted by mini-css-extract-plugin
module.exports = {"sectionGroupsWrapper":"QufzlOxX","sectionGroupTitle":"cMROOiPl","groupWrapper":"uDO29Ec1","citationsSectionWrapper":"EeZNjRvr","citationsTitle":"s0TicgUG"};